import { useSetState } from 'ahooks'
import { Popup, SafeArea } from 'antd-mobile'

import { Calendar } from 'antd-mobile'
import dayjs from 'dayjs'
import React, { useEffect } from 'react'

import HCell from '../../HYBVant/HCell'

import './index.less'
import { isNotEmptyArray } from '@/utils'

interface CalendarCascaderState {
  visible: boolean
  valueRange: any[] | null
  list: [Date, Date] | null
}

interface CalendarCascaderProps {
  columns?: Array<{ label: string; value: string }>[]
  value: [any, any]
  [index: string]: any
}
function HRangeDatePicker(props: CalendarCascaderProps) {
  const {
    title = '日期区间',
    okText = '确认',
    value,
    onConfirm,
    disabled = false,
    readed = false,
    columns,
    selectionMode = 'single',
    timeProps = {
      format: 'HH:mm'
    },
    range = 6
  } = props
  const [{ visible, valueRange, list }, setState] = useSetState<CalendarCascaderState>({
    visible: false,
    list: null,
    valueRange: [dayjs()?.format('YYYY-MM-DD'), dayjs()?.format('YYYY-MM-DD')]
  })

  const confirm = () => {
    onConfirm?.(valueRange?.length && valueRange?.length > 1 ? valueRange : null)
    setState({ visible: false })
  }
  useEffect(() => {
    if (Array.isArray(value) && value.length > 1) {
      setState({
        list: [dayjs(value?.[0])?.toDate() ?? null, dayjs(value?.[1])?.toDate() ?? null],
        valueRange: [dayjs(value?.[0]).format('YYYY-MM-DD'), dayjs(value?.[1]).format('YYYY-MM-DD')]
      })
      return
    }
    setState({ list: null, valueRange: [] })
  }, [value])

  const bool: boolean = !disabled && !readed
  const valueStr =
    isNotEmptyArray(value) && value?.filter(Boolean)?.length > 1 ? value?.join('至') : ''

  return (
    <div className='calender-cascader'>
      <HCell
        value={valueStr}
        showPlaceholder={!value}
        onClick={() => bool && setState({ visible: true })}
        disabled={disabled}
        readed={readed}
      />
      <Popup
        visible={visible}
        onClose={() => setState({ visible: false })}
        onMaskClick={() => setState({ visible: false })}
        className='sheet-popup'
      >
        <div className='calender-cascader-form'>
          <div className='calender-cascader-form-action'>
            <div
              className='calender-cascader-form-action-i'
              onClick={() => setState({ visible: false })}
            >
              取消
            </div>
            <div className='calender-cascader-form-action-ii'>{title}</div>
            <div className='calender-cascader-form-action-iii' onClick={confirm}>
              {okText}
            </div>
          </div>
          <div className='calender-cascader-form-edit'>
            <Calendar
              value={(list as [Date, Date]) ?? undefined}
              selectionMode='range'
              onChange={(val: any) => {
                setState({
                  list: val,
                  valueRange: [
                    dayjs(val?.[0]).format('YYYY-MM-DD'),
                    dayjs(val?.[1]).format('YYYY-MM-DD')
                  ]
                })
              }}
            />
          </div>
          <SafeArea position='bottom' />
        </div>
      </Popup>
    </div>
  )
}
/**
 * 前置化转换 - 用于回显
 * @param value
 * @param config
 * @returns newValue
 */
HRangeDatePicker.convertValue = (value: any, config?: any, values?: any) => {
  return value
}
export default HRangeDatePicker
